module.exports = __webpack_public_path__ + "assets/img/5f03-cp.svg";